/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandNextjs = createReactComponent("brand-nextjs", "IconBrandNextjs", [
  ["path", { d: "M9 15v-6l7.745 10.65a9 9 0 1 1 2.255 -1.993", key: "svg-0" }],
  ["path", { d: "M15 12v-3", key: "svg-1" }]
]);

export { IconBrandNextjs as default };
//# sourceMappingURL=IconBrandNextjs.js.map
